import { useMutation } from '@tanstack/react-query';

import { authMutationKeys } from '../config/auth-mutation-keys';
import { getPasswordResetApi } from './password-reset/client';

async function sendPasswordResetEmail(email: string) {
  const passwordResetApi = getPasswordResetApi();

  await passwordResetApi.post('', {
    email,
  });

  return email;
}

export function useSendPasswordResetEmailMutation() {
  return useMutation({
    mutationFn: (email: Parameters<typeof sendPasswordResetEmail>[0]) =>
      sendPasswordResetEmail(email),
    mutationKey: authMutationKeys.resetPasswordRequest(),
  });
}
